import { QueryClient } from '@tanstack/react-query';

// Single app-wide QueryClient (frontend-snappiness plan, Phase 0.1).
// Defaults give every migrated query stale-while-revalidate behavior:
// revisits within staleTime paint instantly from cache; gcTime keeps
// last-good data around for placeholderData on key changes.
// Exported from a module (not created inline in App.tsx) so non-component
// code — AuthContext logout, SSE handlers — can clear/invalidate it.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      // Focus refetch stays off: Summary has its own 30s-cooldown focus
      // refresh and SSE-driven invalidation; double-refetching on focus
      // would hammer the heavy /summaries endpoint.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
